import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ThemePickerComponent } from '../../../theme/theme-picker/theme-picker.component';

/** Shell footer: copyright, legal links and the theme choice. */
@Component({
  selector: 'app-footer-cabinet',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ThemePickerComponent],
  host: {
    role: 'contentinfo',
  },
})
export class FooterCabinetComponent {
  aboutUrl = input('https://infinitform.com/about/');
  eulaUrl = input('https://infinitform.com/eula/');
  privacyUrl = input('https://infinitform.com/privacy-policy/');

  readonly currentYear = new Date().getFullYear();
}
